const toggleOptionsVisibility = (event) => {
  const target = event.target.classList.contains('select-input')
    ? event.target
    : event.target.closest('.select-input');

  const optionsBlock = target.querySelector('.options');
  if (optionsBlock) optionsBlock.classList.toggle('hidden');
  const selectedBlock = target.querySelector('.selected');
  if (selectedBlock) selectedBlock.classList.toggle('_open');
};

const closeOptions = (event) => {
  const target = event.target.closest('.select-input');

  const optionsBlock = target.querySelector('.options');
  if (optionsBlock) {
    setTimeout(() => {
      optionsBlock.classList.add('hidden');
    }, 200);
  }
};

const init = () => {
  const selectItems = document.querySelectorAll('.variables-property__select');

  selectItems.forEach((selectElem) => {
    const selectInput = selectElem.querySelector('.select-input');
    if (selectInput) selectInput.addEventListener('blur', closeOptions);

    const selectedOptions = selectElem.querySelector('.selected');
    if (selectedOptions) selectedOptions.addEventListener('click', toggleOptionsVisibility);
  });
};

window.initSelectVariables = init;

init();
